export const crawlingStatus = [{
  value: 'Undefined', label: 'Undefined', color: 'gray'
}, {
  value: 'Success', label: 'Success', color: 'green'
}, {
  value: 'Failed', label: 'Failed', color: 'red'
}, {
  value: 'Scheduled', label: 'Scheduled', color: 'yellow'
}, {
  value: 'Running', label: 'Running', color: 'orange'
}];